import { isString } from '@app/typeGuards'

import { isNull } from './isNull'

export const uploadFilesFactory =
  ({ id, callback }: { id: string | number, callback: (id: number, files: File[]) => Promise<void> }) =>
    async (files: File[]): Promise<void> => {
      const parsedId = isString(id) ? parseInt(id) : id

      if (isNaN(parsedId) || !files.length) return

      await callback(parsedId, files)
    }

export const uploadFileFactory =
  ({ id, callback }: { id: string | number, callback: (id: number, file: File) => Promise<void> }) =>
    async (file: File | null): Promise<void> => {
      const parsedId = isString(id) ? parseInt(id) : id

      if (isNaN(parsedId) || isNull(file)) return

      await callback(parsedId, file)
    }
